import tradingStore from 'lib/stores/trading';
import { getMaintenanceStatus } from '../api/maintenance';
import { MaintenanceStatusType } from '../types/api/maintenance';
// Modify the function signature to accept arguments
export async function withMaintenanceGuard(
  // eslint-disable-next-line @typescript-eslint/ban-types
  callback: Function,
) {
  try {
    // API is not ready yet
    const isAllowed = false;

    if (!isAllowed) {
      return callback();
    }

    const response = await getMaintenanceStatus();
    const { data, message } = response.data;

    if (data.status === MaintenanceStatusType.OnMaintenance) {
      return tradingStore
        .getState()
        .setErrorCode(503, message, 'DAILY_MAINTENANCE_MODE');
    }

    // Pass the arguments to the callback function
    return callback();
  } catch (error) {
    // Pass the arguments to the callback function even in case of an error
    return callback();
  }
}
